import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const resetValue = values => {
  if (values && values.debitCard) {
    delete values.debitCard;
  }
};
const AccountType = ({ values }) => (
  <Content>
    {({ accountTypeTitle, accountTypeSubTitle, radioFieldYes = '', radioFieldNo = '' }) => (
      <div>
        <Field name="accountType" subscription={{ touched: true, error: true }}>
          {({ input }) => (
            <GenericFieldWrapper
              inputId="accountType"
              title={accountTypeTitle}
              description={accountTypeSubTitle}
            >
              <GenericRadio.InlineSet
                groupName="accountType-group"
                items={[
                  { id: radioFieldYes, labelText: radioFieldYes },
                  { id: radioFieldNo, labelText: radioFieldNo }
                ]}
                {...input}
                onChange={selectedId => {
                  if (selectedId === radioFieldNo) resetValue(values);
                  input.onChange(selectedId);
                }}
                selectedId={values.accountType}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      </div>
    )}
  </Content>
);

export default AccountType;
